import React, { useEffect } from "react"
import { FormikProps } from "formik"
import SearchInputV2 from "../../../../../components/SearchInputV2/SearchInputV2"
import MultiSelectDropdown from "../../../../../components/MultiSelectDropdown/MultiSelectDropdown"
import styles from "./Sites.module.scss"
import useSitesFilter from "./useSites"
import { useGetAddedByForSitesQuery } from "../../../../../pages/Sites/SiteService"
import data_loader from "../../../../../assets/images/data_loader.gif"
import error_mark from "../../../../../assets/images/error_mark.svg"
import { Countries } from "../../../../../enums/dropdownValues"
import { DropdownObj } from "../../../../../pages/Common/commonTypes"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Link from "@mui/material/Link"
import blue_info_icon from "../../../../../assets/images/blue_info_icon.svg"
import slack_icon from "../../../../../assets/images/slack.svg"

interface SitesFormValues {
    siteId: number | null
    search_site_name: string
    search_pincode: string
    selectedState: any[]
    selectedCity: any[]
    selectedCountry: DropdownObj
    addedBy: any[]
}

interface SitesProps {
    formik: FormikProps<SitesFormValues>
    preSelectedSite: any
    nextClicked: boolean
    setNextClicked: any
    setSiteValue?: any
    showInfoMsg?: boolean
    isSurveyModule?:boolean
}

const Sites = ({
    formik,
    preSelectedSite,
    nextClicked,
    setNextClicked,
    setSiteValue,
    showInfoMsg = false,
    isSurveyModule = false
}: SitesProps) => {
    console.log(typeof setSiteValue)
    const { states, functions } = useSitesFilter()
    const { data: addedByList } = useGetAddedByForSitesQuery()
    useEffect(() => {
        if (preSelectedSite) {
            formik.setFieldValue("siteId", preSelectedSite.site_id)
        }
    }, [preSelectedSite?.site_id])
    useEffect(() => {
        formik.setFieldValue("selectedCountry", { id: 101, title: "India" })
    }, [])

    useEffect(() => {
        functions?.getCountryStates({ country_id: formik.values?.selectedCountry?.id })
        formik.setFieldValue("selectedState", [])
        formik.setFieldValue("selectedCity", [])
    }, [formik.values?.selectedCountry?.id])

    useEffect(() => {
        const { search_site_name, addedBy, search_pincode, selectedState, selectedCity, selectedCountry } =
            formik.values
        const stateFilter = JSON.stringify(selectedState?.length ? selectedState.map(i => i.id) : [])
        const cityFilter = JSON.stringify(selectedCity?.length ? selectedCity.map(i => i.id) : [])
        const addedByFilter = JSON.stringify(addedBy?.length ? addedBy.map(i => i.id) : [])
        functions.getAllSites({
            page: 1,
            per_page: 100000,
            state: stateFilter,
            city: cityFilter,
            site: search_site_name,
            pincode: search_pincode,
            added_by: addedByFilter,
            country_id: selectedCountry?.id,
            updated_at: true,
        })
    }, [
        formik.values.search_pincode,
        formik.values.search_site_name,
        formik.values.addedBy,
        formik.values.selectedState,
        formik.values.selectedCity,
        preSelectedSite,
    ])
    const handleSiteChange = (siteId: number) => {
        if (states?.sitesData && states.sitesData.data) {
            const selectedSite = states.sitesData.data.find(i => i.id === siteId)
            formik.setFieldValue("siteId", siteId)
            formik.setFieldValue("pincode", selectedSite?.pincode)
            formik.setFieldValue("siteName", selectedSite?.name)
            formik.setFieldValue("latitude", selectedSite?.latitude)
            formik.setFieldValue("longitude", selectedSite?.longitude)
            formik.setFieldValue("siteAddress", selectedSite?.address)
            formik.setFieldValue("selectedCountry", {
                id: selectedSite?.country_id,
                title: functions?.getCountryTitleById(selectedSite?.country_id || 101),
            })
            formik.setFieldValue("state", { id: selectedSite?.state_id, title: selectedSite?.state })
            formik.setFieldValue("city", { id: selectedSite?.city_id, title: selectedSite?.city })
            if (setSiteValue !== undefined) setSiteValue(siteId)
        }
    }

    const handleResetFilters = () => {
        formik.setFieldValue("search_site_name", "")
        formik.setFieldValue("search_pincode", "")
        formik.setFieldValue("selectedState", [])
        formik.setFieldValue("selectedCity", [])
        formik.setFieldValue("addedBy", [])
        formik.setFieldValue("selectedCountry", {})
    }

    return (
        <div>
            <div className="weight-500 text-lg mt-10 mb-10">
                Select Site {!formik.values.siteId && <img src={error_mark} alt="" />}
                {showInfoMsg && !isSurveyModule && (
                    <Box display="flex" alignItems="center" gap={1} color="#0430C0">
                        <img src={blue_info_icon} alt="info" width={12} height={12} />
                        <Typography component="span" fontWeight={500} sx={{ fontSize: "12px", lineHeight: "16px" }}>
                            For any new site creation, please create a thread on{" "}
                            <Link
                                href="slack://channel?team=T075ASX9F55&id=C07617WC7KL"
                                underline="always"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                    textDecorationColor: "#0430C0",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                }}
                                color="#0430C0">
                                Cristi Support
                                <img src={slack_icon} width={14} height={14} alt="slack-icon" />
                            </Link>{" "}
                            Slack channel
                        </Typography>
                    </Box>
                )}
            </div>
            <div
                className="p-10"
                style={{
                    border: nextClicked && formik.values.siteId === null ? "1px solid red" : "1px solid #0000000D",
                    borderRadius: 6,
                }}>
                <div className={`${styles.header_container} mt-6`}>
                    <div className={styles.main_container}>
                        <div className={styles.header_container_filters}>
                            <div className={styles.search_filter}>
                                <SearchInputV2
                                    placeholder="Search by Site Name/ID"
                                    onSearch={(val: string) => formik.setFieldValue("search_site_name", val)}
                                    value={formik.values.search_site_name}
                                    searchIcon={true}
                                />
                            </div>
                            <div className={styles.search_filter}>
                                <SearchInputV2
                                    placeholder="Search by Pincode"
                                    onSearch={(val: string) => formik.setFieldValue("search_pincode", val)}
                                    value={formik.values.search_pincode}
                                    type="number"
                                    maxCharacter={6}
                                    searchIcon={true}
                                />
                            </div>
                            <div className={styles.dropdown_filter} style={{ width: "100px" }}>
                                <MultiSelectDropdown
                                    title="Select Country"
                                    options={Countries?.map((state: any) => ({
                                        id: state?.id,
                                        title: state?.title,
                                    }))}
                                    id="selectedCountry"
                                    selectionType="single"
                                    onChange={() => {}}
                                    selectedOptions={
                                        formik.values?.selectedCountry
                                            ? [
                                                  {
                                                      id: formik.values?.selectedCountry?.id,
                                                      title: formik.values?.selectedCountry?.title,
                                                  },
                                              ]
                                            : []
                                    }
                                    onSelect={(value: any) => {
                                        formik.setFieldValue("selectedCountry", value)
                                        functions.handleCountryChange(value)
                                    }}
                                />
                            </div>
                            <div className={styles.dropdown_filter}>
                                <MultiSelectDropdown
                                    title="Select State"
                                    options={states.states?.map(state => ({ id: state?.id, title: state?.name }))}
                                    id="states"
                                    onChange={() => {}}
                                    selectedOptions={
                                        formik.values.selectedState?.length ? formik.values.selectedState : []
                                    }
                                    onSelect={(value: any) => {
                                        formik.setFieldValue("selectedState", value)
                                        functions.handleStateChange(value)
                                    }}
                                />
                            </div>
                            <div className={styles.dropdown_filter}>
                                <MultiSelectDropdown
                                    title="Select City"
                                    options={states.cities?.map(city => ({ id: city?.id, title: city?.name }))}
                                    id="cities"
                                    onChange={() => {}}
                                    selectedOptions={
                                        formik.values.selectedCity?.length ? formik.values.selectedCity : []
                                    }
                                    onSelect={(value: any) => {
                                        formik.setFieldValue("selectedCity", value)
                                        functions.handleCityChange(value)
                                    }}
                                    disabled={formik.values?.selectedState?.length === 0}
                                />
                            </div>
                            <div className={styles.dropdown_filter}>
                                <MultiSelectDropdown
                                    title="Added By"
                                    options={addedByList?.map(obj => ({ id: obj?.id, title: obj?.user_name }))}
                                    onChange={() => {}}
                                    id="addedBy"
                                    selectedOptions={formik.values.addedBy?.length ? formik.values.addedBy : []}
                                    onSelect={(value: any) => {
                                        formik.setFieldValue("addedBy", value)
                                        functions.handleAddedByChange(value)
                                    }}
                                />
                            </div>
                            <div className={styles.filter_reset} onClick={handleResetFilters}>
                                Reset
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="d-grid gap-16"
                    style={{
                        gridTemplateColumns: states.isSitesLoading ? "100%" : "33% 33% 33%",
                        maxHeight: 300,
                        overflow: "auto",
                    }}>
                    {states.isSitesLoading ? (
                        <div className={styles.loader_container}>
                            <img src={data_loader} alt="loading" width="150" />
                        </div>
                    ) : (
                        <>
                            {states?.displayedSites?.map(option => (
                                <label className="d-flex align-items-center gap-8 text-md" key={option.id}>
                                    <input
                                        type="radio"
                                        name="siteId"
                                        value={option.id}
                                        checked={formik.values.siteId === option.id}
                                        onChange={() => {
                                            handleSiteChange(option.id)
                                            if (nextClicked) setNextClicked(false)
                                        }}
                                    />
                                    {option.name}
                                </label>
                            ))}
                            {states.sitesData?.data && states.sitesData?.data?.length > 17 && (
                                <div className="mt-8">
                                    <button
                                        type="button"
                                        onClick={() => functions?.setShowAllSites(prev => !prev)}
                                        className={styles.showToggle}>
                                        {states?.showAllSites ? "▲ Show Less" : "▼ Show More"}
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Sites
